/**
 * @generated SignedSource<<2587aed00fa8e0009b3be6125c628d6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Notifications$data = {
  readonly notifications: {
    readonly unseenNotificationCount: number;
  } | null;
  readonly " $fragmentType": "Nav4Notifications";
};
export type Nav4Notifications$key = {
  readonly " $data"?: Nav4Notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Notifications">;
};

import Nav4NotificationsRefetchableQuery_graphql from './Nav4NotificationsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "collabContextRoutingAri"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": Nav4NotificationsRefetchableQuery_graphql
    }
  },
  "name": "Nav4Notifications",
  "selections": [
    {
      "concreteType": "InfluentsNotificationQuery",
      "kind": "LinkedField",
      "name": "notifications",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "collabContextRoutingAri",
              "variableName": "collabContextRoutingAri"
            }
          ],
          "kind": "ScalarField",
          "name": "unseenNotificationCount"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "b6d1ac4e3d580a2134a764b9b2657a38";

export default node;
